<template>
    <the-btn
        class="btn-secondary"
        text="Pobierz listę aktywnych promocji"
        icon="Download"
        :loading-status="status"
        @click.native="downloadActivePromos"
    />
</template>

<script>
export default {
    name: 'ActivePromosBtn',

    props: {
        filters: {
            type: Object,
            required: true
        }
    },

    computed: {
        status() {
            return this.$store.getters.getActivePromosDownloadStatus
        }
    },

    methods: {
        async downloadActivePromos() {
            if (this.status === 'loading') {
                return
            }

            this.$store.commit('SET_ACTIVE_PROMOS_DOWNLOAD_STATUS', 'loading')

            const { paramsPromos } = await this.$store.dispatch('setPromoFilterQueryParams')
            const { id, type, company_id, 'subscription|merchant_id': merchant_id } = paramsPromos

            const params = {
                state: paramsPromos.state,
                subscription_state: paramsPromos['subscription|state'],
                merchant_ids: merchant_id.split(',').map(Number),
                types: type ? type.split(',') : undefined,
                company_ids: company_id ? company_id.split(',').map(Number) : undefined,
                id: id ? id.split(',').map(Number) : undefined,
                start_at: paramsPromos.start_at,
                end_at: paramsPromos.end_at,
                query: paramsPromos.query,
                loyalty: paramsPromos.loyalty
            }

            try {
                const { status, data } = await this.$store.$api.post('download_active_promos', params)

                if (status !== 200 || !data.data) {
                    throw new Error(data.message || 'Error POST download_active_promos')
                }

                const queueId = data.data.uuid

                const checkProgress = async () => {
                    // Check progress request
                    const { status, data } = await this.$store.$api.get(
                        `download_active_promos/${queueId}/status`
                    )

                    if (status !== 200) {
                        // Handle error
                        throw new Error(data?.message || `Error GET download_active_promos/${queueId}/status`)
                    }

                    return data.data
                }

                let progress = await checkProgress()

                const waitForCompletion = async () => {
                    const { state, file_url, file_name } = progress

                    if (state === 'error') {
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                        return
                    } else if (state !== 'finished') {
                        // If not done yet, wait 2s and check again
                        await new Promise(resolve => setTimeout(resolve, 2000))
                        progress = await checkProgress()
                        await waitForCompletion() // Recursively check again
                        return
                    }

                    this.$functions.downloadFile(file_url, file_name)
                }

                await waitForCompletion()
            } catch(err) {
                console.log(err)

                this.$store
                    .dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
            } finally {
                this.$store.commit('SET_ACTIVE_PROMOS_DOWNLOAD_STATUS', 'idle')
            }
        }
    }
}
</script>
